"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.YandexLinear = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var YandexLinear = function YandexLinear(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 36,
    height: 24,
    viewBox: "0 0 36 24",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#YandexLinear_svg__YandexLinear_svg__clip0_19504_92429)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.095.85h-12.19C5.8.85.85 5.8.85 11.905c0 6.106 4.95 11.056 11.056 11.056h12.188c6.106 0 11.056-4.95 11.056-11.055C35.15 5.8 30.2.85 24.095.85zM11.905 0C5.33 0 0 5.33 0 11.905c0 6.576 5.33 11.906 11.905 11.906h12.19C30.67 23.811 36 18.481 36 11.906 36 5.33 30.67 0 24.095 0h-12.19z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.527 12.043a7.43 7.43 0 00-1.504-4.49l1.001-.754a8.684 8.684 0 011.756 5.244c0 1.85-.574 3.562-1.566 4.973l-1.025-.721a7.345 7.345 0 001.338-4.252zm3.117-.046c0-2.136-.747-4.142-1.917-5.829l1.03-.714c1.29 1.86 2.14 4.111 2.14 6.543 0 2.348-.778 4.517-1.988 6.344l-1.045-.692c1.095-1.655 1.78-3.587 1.78-5.652z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.701 12.063a5.191 5.191 0 00-1.148-3.256l.978-.783a6.447 6.447 0 01.244 7.76l-1.023-.723a5.2 5.2 0 00.95-2.998z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.221 11.904a7.576 7.576 0 1115.153 0 7.576 7.576 0 01-15.153 0z",
    fill: "#FC3F1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.868 16.455h1.582V7.364h-2.302c-2.315 0-3.532 1.19-3.532 2.943 0 1.4.667 2.224 1.858 3.074l-2.067 3.074h1.714l2.302-3.44-.798-.537c-.968-.654-1.439-1.164-1.439-2.263 0-.968.68-1.622 1.975-1.622h.707v7.862z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "YandexLinear_svg__YandexLinear_svg__clip0_19504_92429"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h36v24H0z"
  }))));
};

exports.YandexLinear = YandexLinear;
var _default = YandexLinear;
exports.default = _default;